const isArrayLike = (x) => x != null && typeof x !== "function" && x.length !== void 0;
export {
  isArrayLike
};
